import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { ReactComponent as FormEdit } from "assets/icons/form-edit.svg";
import { Form } from 'formik';

export const Style = styled(Modal)`
  .modal-content {
    border-radius: 10px;
  }

  .modal-dialog {
    max-width: 648px !important;
    min-height: 316px !important;
    width: 100% !important;

    @media (max-width: 768px) {
      width: auto !important;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 35px 26px 35px 26px;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 15px;

  .wrapper {
    display: flex;
    justify-content: center;

    img {
      margin-right: 15px;
    }
  }

  span {
    color: #000fff;
    font-size: 1.25rem;
  }

  svg {
    color: #000fff;
    cursor: pointer;
  }
`;

export const Body = styled.div`
  h2 {
    color: #000fff;
    font-size: 1.5rem;
    line-height: 24px;
    text-align: left;
    margin-bottom: 25px;
    width: 100%;
    text-align: center;
  }

  p {
    color: ${({ theme }) => theme.colors.black};
    font-size: 1rem;
    line-height: 25px;
    margin-bottom: 0;

    @media only screen and (max-width: 500px) {
      text-align: center;
    }
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 30px;

  > p {
    margin-bottom: 15px;
  }

  > svg {
    margin-right: 15px;
    flex-shrink: 0;

    @media only screen and (max-width: 500px) {
      margin-right: 0;
      margin-bottom: 15px;
    }
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  button:nth-child(2) {
    margin-left: 27px;
  }

  button {
    width: 100%;
    height: 50px;
  }
`;

export const ValidationContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ValidationItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
  gap: 20px;
`;

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin: 15px 0;

  p {
    color: #000000;
    font-size: 0.75rem;
    line-height: 14px;
  }
`;

export const ContentButtons = styled.div`
  display: flex;
  justify-content: space-around;

  button {
    width: 40%;
  }
`;

export const TextTimer = styled.p`
  text-align: center;

  a {
    color: #0000ff;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ValidationItemContent = styled.div`
  display: flex;
  align-items: center;
`;

export const ValidationItemLabel = styled.span`
  color: #262626;
  margin-right: 15px;
`;

export const ValidationItemValue = styled.span`
  color: #262626;
`;

export const ButtonEdit = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  span {
    margin-left: 10px;
    font-size: 1rem;
    color: #757575;
    cursor: pointer;
  }

  @media (max-width: 768px){
    justify-content: flex-end;
  }
`;

export const FormEditIcon = styled(FormEdit)`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;
